import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
export function StickyCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > window.innerHeight * 0.9);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-106" data-mp="3ucc8pdxhapod">
      {visible ? <motion.div initial={{
      y: 24,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 24,
      opacity: 0
    }} transition={{
      duration: 0.2,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-50 border-t border-cream/10 bg-plum-deep/95 backdrop-blur" data-id="element-107" data-mp="3ubamcdb0igrc">
          <div className="mx-auto flex max-w-content flex-wrap items-center justify-between gap-3 px-6 py-3" data-id="element-108" data-mp="c4w7mc4x62rw">
            <p className="font-sans text-sm text-cream/80" data-id="element-109" data-mp="gzjuy7o6sr4w">
              Kit Maestro completo ·{' '}
              <span className="font-semibold text-cream" data-id="element-110" data-mp="26sx6ljyhzfi">$18.900 ARS</span>{' '}
              <span className="text-cream/50 line-through" data-id="element-111" data-mp="24pxf9t04rxl">$51.500</span>
            </p>
            <CtaButton compact data-id="element-112" data-mp="gx04c54ijw0w" />
          </div>
        </motion.div> : null}
    </AnimatePresence>;
}